import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const printPDF = ({
    reportData,
    dynamicColumns,
    footerTotals,
    summReportData,
    fromDate,
    toDate,
    selectedSectionName
}) => {

    const formatAmount = (amount) =>
        Number(amount || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

    const formatDate = (dateStr) => {

        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "2-digit" }); // Jan, Feb, etc.
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const doc = new jsPDF("landscape", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const totalPagesExp = "{total_pages_count_string}";

    // ================= HEADER =====================

    function drawPageHeader(doc) {

        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("St. Haris High School & Hajra Girls Jr. College", pageWidth / 2, 15, { align: "center" });

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");

        doc.text(`Period : ${formatDate(fromDate)} To ${formatDate(toDate)}`, 15, 22, { align: "left" });

        doc.setFontSize(12);
        doc.text(`Daily Fee Register - ${selectedSectionName} Section`, pageWidth / 2, 22, { align: "center" });

        doc.setDrawColor(90, 90, 90);
        doc.setLineWidth(0.4);
        doc.line(14, 28, pageWidth - 14, 28);

    }

    function drawPageFooter(doc) {

        const pageNumber = doc.internal.getNumberOfPages();

        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");

        doc.text(
            `Page ${pageNumber} of ${totalPagesExp}`,
            pageWidth - 3,
            pageHeight - 10,
            { align: "right" }
        );
    }

    drawPageHeader(doc);

    // ================= TABLE HEADER =====================

    const tableColumn = [
        "Date",
        "Rcpt No.",
        "GR No",
        "Std / Div",
        "Period",
        ...dynamicColumns,
        "Total"
    ];

    // ================= TABLE BODY =====================

    const tableRows = reportData.map(row => [
        row.rcpt_date,
        row.rcpt_no,
        row.gr_no,
        row.std_div,
        row.from_period,

        ...dynamicColumns.map(col =>
            formatAmount(row.fee_heads?.[col] || 0)
        ),

        formatAmount(row.tot_amt)

    ]);

    // ================= FOOTER =====================

    const footerRow = [

        {
            content: "Total :",
            colSpan: 5,
            styles: {
                halign: "left",
                fontStyle: "bold"
            }
        },

        ...dynamicColumns.map(col => ({
            content: formatAmount(footerTotals[col]),
            styles: {
                fontSize: 8,
                halign: "right",
                fontStyle: "bold"
            }
        })),

        {
            content: formatAmount(
                Object.values(footerTotals).reduce((a, b) => a + b, 0)
            ),
            styles: {
                fontSize: 8,
                halign: "right",
                fontStyle: "bold"
            }
        }

    ];

    // ================= COLUMN WIDTH =====================

    const leftRightMargin = 14 * 2;               // same as your line margins
    const pageContentWidth = pageWidth - leftRightMargin;

    // Fixed columns
    const dateWidth = 18;
    const rcptWidth = 18;
    const grWidth = 14;
    const stdWidth = 18;
    const periodWidth = 22;
    const totalWidth = 18;

    // Width available for dynamic fee heads
    const fixedWidth =
        dateWidth +
        rcptWidth +
        grWidth +
        stdWidth +
        periodWidth +
        totalWidth;

    // Dynamic fee head width
    let dynamicWidth =
        (pageContentWidth - fixedWidth) / dynamicColumns.length;

    // Keep within reasonable limits
    dynamicWidth = Math.max(12, Math.min(dynamicWidth, 22));

    const columnStyles = {

        0: { cellWidth: dateWidth, halign: "center" },
        1: { cellWidth: rcptWidth, halign: "left" },
        2: { cellWidth: grWidth, halign: "center" },
        3: { cellWidth: stdWidth, halign: "left" },
        4: { cellWidth: periodWidth, halign: "left" }

    };

    // Dynamic Fee Heads

    dynamicColumns.forEach((_, index) => {

        columnStyles[index + 5] = {
            cellWidth: dynamicWidth,
            halign: "right"
        };

    });

    // Total

    columnStyles[dynamicColumns.length + 5] = {
        cellWidth: totalWidth,
        halign: "right"
    };

    // const columnStyles = {
    //     0: {cellWidth: 20,
    //         halign: "center"},
    //     1: {cellWidth: 22,
    //         align: "left"},
    //     2: {cellWidth: 18,
    //         halign: "center"},
    //     3: {cellWidth: 22,
    //         halign: "left" },
    //     4: {cellWidth: 22,
    //         halign: "left"}
    // };

    // // Dynamic Fee Head Columns
    // dynamicColumns.forEach((_, index) => {
    //     columnStyles[index + 5] = {
    //         cellWidth: 25,
    //         halign: "right"
    //     };
    // });

    // // Total Column
    // columnStyles[dynamicColumns.length + 5] = {
    //     cellWidth: 22,
    //     halign: "right"
    // };

//    const totalPagesExp = "{total_pages_count_string}";
    // ================= TABLE =====================

    autoTable(doc, {

        head: [tableColumn],
        body: tableRows,
        foot: [footerRow],
        showFoot: "lastPage",
        startY: 34,
        margin: {
            top: 34,
            left: 14,
            right: 14,
            bottom: 15
        },
        theme: "grid",

        styles: {
            fontSize: 8.2,
            textColor: [0, 0, 0],
            cellPadding: 2,
            overflow: "linebreak",
            valign: "middle",
            lineColor: [90, 90, 90],
            lineWidth: 0.2
        },

        // headStyles: {

        //     fillColor: [0, 102, 204],
        //     textColor: 255,
        //     fontStyle: "bold",
        //     halign: "center",
        //     valign: "middle"
        // },

        headStyles: {
            fillColor: [252, 252, 252],   // Light Grey
            textColor: [0, 0, 0],         // Black
            fontStyle: "bold",
            halign: "center",
            valign: "middle",
            lineColor: [90, 90, 90],
            lineWidth: 0.2
        },

        footStyles: {
            fillColor: [252, 252, 252],
            textColor: 0,
            fontStyle: "bold",
            lineColor: [90, 90, 90],
            lineWidth: 0.2
        },

        columnStyles,

        didParseCell(data) {

            // Left align selected columns
            if (data.section === "body") {
                if ([1, 3, 4].includes(data.column.index))
                    data.cell.styles.halign = "left";
                if ([0, 2].includes(data.column.index))
                    data.cell.styles.halign = "center";
            }

        },
        
        didDrawPage() {

            drawPageHeader(doc);
            drawPageFooter(doc);

            // const pageNumber = doc.internal.getNumberOfPages();
            // doc.setFontSize(10);
            // doc.text(
            //     `Page ${pageNumber} of ${totalPagesExp}`,
            //     pageWidth - 7,
            //     pageHeight - 10,
            //     { align: "right" }
            // );

        }

    });

    /// Payment Mode Summary

    let paymentSummaryY = doc.lastAutoTable.finalY;

    const summaryHeight = 22;   // estimate

    if (paymentSummaryY + summaryHeight > pageHeight - 20) {

        doc.addPage();

        //drawPageHeader(doc);

        paymentSummaryY = 34;
    }

    // Heading
    // doc.setFont("helvetica", "bold");
    // doc.setFontSize(11);
    // doc.text("Payment Summary", 15, paymentSummaryY);

    // Summary Table
    autoTable(doc, {
        startY: paymentSummaryY + 4,

        head: [[
            "Cash",
            "Cheque",
            "Online",
            "NEFT/IPMS",
        ]],

        body: summReportData.map(r => [
            formatAmount(r.cash),
            formatAmount(r.cheque),
            formatAmount(r.online),
            formatAmount(r.neft),
        ]),

        theme: "grid",

        tableWidth: 215,

        styles: {
            fontSize: 9,
            textColor: [0, 0, 0],
            cellPadding: 2,
            lineColor: [90, 90, 90],
            lineWidth: 0.2,
            fontStyle: "bold"
        },

        headStyles: {
            fontSize: 8.5,
            fillColor: [252, 252, 252],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            halign: "center",
            lineColor: [90, 90, 90],
            lineWidth: 0.2
        },

        columnStyles: {
            0: {
                cellWidth: 35,
                halign: "right"
            },
            1: {
                cellWidth: 35,
                halign: "right"
            },
            2: {
                cellWidth: 35,
                halign: "right"
            },
            3: {
                cellWidth: 35,
                halign: "right"
            },
        },
        didDrawPage() {
            drawPageHeader(doc);
            drawPageFooter(doc);
        }
    });

    if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
    }

    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;

    document.body.appendChild(iframe);

    iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
    };

//    doc.save("DailyFeeRegister.pdf");

};
